import { ButtonComponent } from '@/components/commons/buttons/ButtonComponent'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { Modal } from '@/components/modal/Modal'

interface DealSyncContactsInvitedProps {
  isOpen: boolean
  onClose: () => void
}

export const DealSyncContactsInvited = ({
  isOpen,
  onClose,
}: DealSyncContactsInvitedProps) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      // title="🚀 Discover Your VIP Network"
      size="xl"
    >
      <div className="flex flex-column gap-24 gap-36--desktop items-center px-30--tablet">
        <Title variation="regular" sizeClass="text-20--tablet text-center">
          Your VIP Connection Requests Are Sent 🎉
        </Title>
        <Text className="text-center">
          {' '}
          Great job! Your VIP connection requests are on their way. We’ll notify
          you via email as these valuable relationships are confirmed. You’re
          accelerating your professional growth on Creatorland—one VIP at a
          time!
        </Text>

        <ButtonComponent
          fullWidth
          label="back to my profile"
          onClick={onClose}
        />
      </div>
    </Modal>
  )
}
